import { FC, InputHTMLAttributes, ReactElement, useEffect, useRef, useState } from 'react';
import ReactPinField, { PinField } from 'react-pin-field';
import cn from 'classnames';
import { ErrorMessage } from 'core/components/common/ErrorMessage';
import { InputModeType } from 'core/types';

import './style.scss';

export interface ICodeFieldProps
  extends Omit<Partial<InputHTMLAttributes<HTMLInputElement>>, 'onChange' | 'onBlur'> {
  name: string;
  error?: string;
  label?: string | ReactElement;
  value?: string;
  inputMode?: InputModeType;
  onChange?: (name: string, value: any) => void;
  onBlur?: () => void;
  parsers?: Array<(value: string, name: string) => string>;
  length: number;
  classNames?: {
    root?: string;
    label?: string;
    error?: string;
    input?: string;
  };
}

export const CodeField: FC<ICodeFieldProps> = (props) => {
  const { name, classNames, error, label, length, value, onChange, onBlur, placeholder, inputMode} = props;

  const refInputs = useRef<PinField>(null);

  useEffect(() => {
    value && refInputs?.current?.inputs?.forEach((item, idx) => (item.value = value[idx] || ''));
  }, []);

  const [isFocus, setIsFocus] = useState<boolean>(false);

  const isEmpty = !!`${props.value || ''}`.length || isFocus;

  return (
    <div
      className={cn(
        'pin-code-box',
        { 'pin-code__invalid': !!error },
        { 'pin-code__active': isFocus },
        { 'pin-code__no-empty': isEmpty },
        { 'pin-code__disabled': props.disabled },
        classNames?.root
      )}
    >
      {label && (
        <label className={cn('pin-code__label', classNames?.label)} htmlFor={name}>
          {label}
        </label>
      )}
      <div className="input-keys">
        <ReactPinField
          ref={refInputs}
          name={name}
          placeholder={placeholder}
          onChange={(value) => {
            onChange && onChange(name, value);
            refInputs?.current?.inputs?.forEach((item) => {
              if (item.value) {
                item.classList.add('pin-code__no-empty');
              } else {
                item.classList.remove('pin-code__no-empty');
              }
            });
          }}
          length={length}
          validate={/^[0-9]$/}
          format={(key) => key}
          defaultValue={value}
          onFocus={(e) => {
            setIsFocus(true);
            e.target.classList.add('pin-code_key_active');
          }}
          onBlur={(e) => {
            e.target.classList.remove('pin-code_key_active');
            let focus = false;

            setTimeout(() => {
              refInputs?.current?.inputs?.forEach((item) => {
                if (item.classList.value.indexOf('pin-code_key_active') > -1) {
                  focus = true;
                }
              });

              if (!focus) {
                onBlur && onBlur();
                setIsFocus(false);
              }
            });
          }}
          inputMode={inputMode}
        />
      </div>
      {error && <ErrorMessage classError={classNames?.error} message={error} />}
    </div>
  );
};
